// extracted by mini-css-extract-plugin
export default {"container":"Table_container__PrCXA","wrapperTable":"Table_wrapperTable__Erkro"};